import {Component, Input} from '@angular/core';
import {CustomFormControl} from '../../custom-form-control';
import {PgCalculationResult} from '../../../../../models/sales-pg.model';
import {FileService} from '../../../../../services/file.service';

@Component({
    selector: 'app-variant-radio',
    templateUrl: './variant-radio.component.html',
    styleUrls: ['./variant-radio.component.less'],
})
export class VariantRadioComponent extends CustomFormControl {
    @Input() variant: PgCalculationResult;

    constructor(private fileService: FileService) {
        super();
    }

    handleClick() {
        this.control.setValue(this.variant);
    }

    get selected() {
        return  this.control.value === this.variant;
    }

    handleOWUClick($event) {
        $event.stopPropagation();
        if (this.variant?.owuHash) {
            this.fileService.getTokenByHash(this.variant?.owuHash);
        }
    }

    handleKIDClick($event) {
        $event.stopPropagation();
        if (this.variant?.kidHash) {
            this.fileService.getTokenByHash(this.variant?.kidHash);
        }
    }
}
